/**
 * Pre-Orders Carousel
 * Scrolls through pre-order cards with arrow navigation.
 * Uses Dawn's icon-caret.svg for arrows.
 */

class PreorderCarousel extends HTMLElement {
  connectedCallback() {
    this.scrollContainer = this.querySelector('.pre-orders__scroll');
    this.prevBtn = this.querySelector('.pre-orders__arrow--prev');
    this.nextBtn = this.querySelector('.pre-orders__arrow--next');

    if (!this.scrollContainer || !this.prevBtn || !this.nextBtn) return;

    this.prevBtn.addEventListener('click', () => this.scroll('prev'));
    this.nextBtn.addEventListener('click', () => this.scroll('next'));
    this.scrollContainer.addEventListener('scroll', () => this.updateArrows());

    this.updateArrows();
  }

  scroll(direction) {
    const card = this.scrollContainer.querySelector('.preorder-card');
    if (!card) return;

    const scrollAmount = card.offsetWidth + parseInt(getComputedStyle(this.scrollContainer).gap);

    if (direction === 'next') {
      this.scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      this.scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  }

  updateArrows() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;

    this.prevBtn.disabled = scrollLeft <= 1;
    this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
  }
}

if (!customElements.get('preorder-carousel')) {
  customElements.define('preorder-carousel', PreorderCarousel);
}
